<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            @click="$emit('close')"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Alterar dados de rematrícula
          </h4>
        </div>
        <div class="modal-body--scrollable">
          <table class="table table-striped modal__table">
            <tbody>
              <tr>
                <th>ID</th>
                <td>{{ reenrollment.id }}</td>
              </tr>
              <tr>
                <th>Tipo de rematrícula</th>
                <td>{{ reenrollment.translated_fee_type }}</td>
              </tr>
              <tr>
                <th>Valor a ser cobrado</th>
                <td>{{ reenrollment.due_amount | formatCurrency }}</td>
              </tr>
              <tr>
                <th>Parcelas</th>
                <td>{{ reenrollment.installments }}</td>
              </tr>
              <tr>
                <th>Semestre</th>
                <td>{{ reenrollment.period }}</td>
              </tr>
              <tr>
                <th>Data de início</th>
                <td>{{ reenrollment.start_date | formatDate }}</td>
              </tr>
            </tbody>
          </table>
          <div class="modal-body">
            <div v-if="inputError" class="alert alert-danger">
              {{ inputError }}
            </div>
            <label>Tipo de taxa de rematrícula</label>
            <select class="form-control" v-model="params.fee_type" @change="clearInputError">
              <option
                v-for="(feeType, index) in feeTypes"
                :value="feeType.value"
                :key="index"
              >
                {{ feeType.label }}
              </option>
            </select>
            <br>

            <div>
              <label>Número de parcelas</label>
              <input
                class="form-control"
                type="number"
                v-model="params.installments"
                @focus="clearInputError"
              >
            </div>
            <br>

            <date-field label="Data de Início" v-model="params.start_date" @input="clearInputError" />

            <money-field
              label="Valor da mensalidade sem desconto"
              v-model="params.full_amount"
              @focus="clearInputError"
            />

            <money-field
              label="Valor da taxa de rematrícula"
              v-model="params.fee_amount"
              v-if="reenrollmentFee"
              @focus="clearInputError"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="updateReenrollment">
            Salvar
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { MoneyField, DateField } from 'components/form';
import ReenrollmentService from 'services/ReenrollmentService';
import moment from 'moment';

export default {
  data() {
    return {
      inputError: null,
      feeTypes: [],
      params: { fee_type: null },
    };
  },
  components: { MoneyField, DateField },
  props: {
    reenrollment: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.loadFeeTypes();
    this.params = { ...this.reenrollment };
    this.params.start_date = moment(this.params.start_date).format('DD/MM/YYYY');
  },
  computed: {
    reenrollmentFee() {
      return this.params.fee_type === 'reenrollment_fee';
    },
  },
  methods: {
    ...mapActions([
      'loadStudentBillings',
    ]),

    clearInputError() {
      this.inputError = null;
    },

    loadFeeTypes() {
      ReenrollmentService.enums()
        .then((response) => {
          this.feeTypes = response.data.fee_types;
        })
        .catch(() => {
          this.$emit('close');
          this.$alert.notifyAlert(
            'Não foi possível carregar os tipos de taxa de rematrícula',
          );
        });
    },

    notChanged() {
      return (
        (this.params.fee_type === this.reenrollment.fee_type)
        && (this.params.installments === this.reenrollment.installments)
        && (this.params.start_date === moment(this.reenrollment.start_date).format('DD/MM/YYYY'))
        && (this.params.full_amount === this.reenrollment.full_amount)
        && (this.params.fee_amount === this.reenrollment.fee_amount)
      );
    },

    updateReenrollment() {
      if (this.notChanged()) {
        this.inputError = 'Nada foi alterado';
        return;
      }

      if (!this.reenrollmentFee) {
        this.params.fee_amount = 0.0;
      }

      this.$loader.show();

      ReenrollmentService.updateReenrollment(this.reenrollment.id, this.params)
        .then(() => {
          this.loadStudentBillings();
          this.$alert.notifySuccess('Rematrícula atualizada com sucesso');
          this.$emit('close');
        })
        .catch(({ response: { data } }) => {
          this.inputError = data.message.join('<br>');
        })
        .finally(() => this.$loader.hide());
    },
  },
};
</script>
